<template>
  <div>
    <li class="call-item">
      <v-btn
        fab
        outlined
        color="grey lighten-1"
        :small="this.$vuetify.breakpoint.xs"
        @click="$emit('cameraAction')"
        :disabled="!permission"
      >
        <v-icon color="grey" size="28" v-if="video"> mdi-video </v-icon>
        <v-icon color="grey" size="28" v-else> mdi-video-off </v-icon>
      </v-btn>
    </li>
    <li class="call-item">
      <v-btn
        fab
        outlined
        color="grey lighten-1"
        :small="this.$vuetify.breakpoint.xs"
        @click="$emit('microphoneAction')"
        :disabled="!permission"
      >
        <v-icon color="grey" size="28" v-if="mic"> mdi-microphone </v-icon>
        <v-icon color="grey" size="28" v-else> mdi-microphone-off </v-icon>
      </v-btn>
    </li>
    <li class="call-item">
      <v-btn
        fab
        outlined
        color="grey lighten-1"
        :small="this.$vuetify.breakpoint.xs"
        @click="$emit('fullScreen')"
        :disabled="!permission"
      >
        <v-icon color="grey" size="28" v-if="!videoFullscreen">
          mdi-fullscreen
        </v-icon>
        <v-icon color="grey" size="28" v-else> mdi-fullscreen-exit </v-icon>
      </v-btn>
    </li>
    <li class="call-item">
      <v-btn
        fab
        outlined
        color="grey lighten-1"
        :small="this.$vuetify.breakpoint.xs"
        @click="
          ($store.state.videoChat.showConversation = !$store.state.videoChat
            .showConversation),
            ($store.state.videoChat.messageNotif = false)
        "
      >
        <v-badge
          left
          dot
          offset-x="30"
          offset-y="-5"
          color="pink"
          v-if="$store.state.videoChat.messageNotif"
        >
        </v-badge>
        <v-icon>mdi-forum</v-icon>
      </v-btn>
    </li>
    <li class="call-item">
      <v-btn
        fab
        outlined
        color="grey lighten-1"
        :small="this.$vuetify.breakpoint.xs"
        @click="
          sharingScreen
            ? $emit('stopSharingScreen')
            : $emit('startSharingScreen')
        "
      >
        <v-icon size="28" v-if="!sharingScreen"> mdi-television </v-icon>
        <v-icon v-else color="red" size="28"> mdi-television-stop </v-icon>
      </v-btn>
    </li>
  </div>
</template>

<script>
export default {
  name: "action_btns",
  data() {
    return {};
  },
  props: {
    permission: undefined,
    video: undefined,
    mic: undefined,
    videoFullscreen: undefined,
    sharingScreen: undefined,
  },
  methods: {},
};
</script>

<style>
.call-icons .call-items .call-item {
  display: inline-block;
  text-align: center;
  margin-right: 15px;
}
.call-icons .call-items .call-item:last-child {
  margin-right: 0;
}
.call-icons .call-items .call-item a {
  color: #777;
  border: 1px solid #ddd;
  width: 50px;
  height: 50px;
  align-items: center;
  border-radius: 50px;
  display: inline-flex;
  font-size: 20px;
  justify-content: center;
  transform: scale(1);
  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1);
}
.call-icons .call-items .call-item:hover {
  transform: scale(1.25);
}
</style>
